module.exports = __webpack_public_path__ + "static/img/four.afb5099.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/voice/four.png
// module id = WSI9
// module chunks = 0